var _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPaidPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.3,
    cy: 7.3,
    r: 5.95,
    fill: "#99D6A2",
    stroke: "#3AB54A",
    strokeWidth: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.06494 11.4999V3.09991H7.63185V11.4999H7.06494ZM8.56864 5.87257C8.54099 5.60788 8.4223 5.40226 8.21259 5.2557C8.00288 5.10913 7.71827 5.03585 7.35877 5.03585C7.11449 5.03585 6.90823 5.06866 6.74 5.13429C6.57177 5.19773 6.44272 5.28632 6.35284 5.40007C6.26527 5.51382 6.22148 5.64288 6.22148 5.78726C6.21687 5.90757 6.24337 6.01257 6.30099 6.10226C6.36091 6.19195 6.44272 6.2696 6.54642 6.33523C6.65012 6.39866 6.76996 6.45445 6.90593 6.50257C7.04189 6.54851 7.18708 6.58788 7.34148 6.6207L7.97753 6.76507C8.28634 6.8307 8.56979 6.9182 8.8279 7.02757C9.08601 7.13695 9.30955 7.27148 9.49852 7.43116C9.68749 7.59085 9.83383 7.77898 9.93753 7.99554C10.0435 8.2121 10.0977 8.46038 10.1 8.74038C10.0977 9.15163 9.98708 9.5082 9.76815 9.81007C9.55152 10.1098 9.23811 10.3427 8.8279 10.509C8.42 10.673 7.92798 10.7551 7.35185 10.7551C6.78033 10.7551 6.28255 10.6719 5.85852 10.5057C5.43679 10.3394 5.10724 10.0934 4.86988 9.76741C4.63481 9.43929 4.51152 9.03351 4.5 8.55007H5.9484C5.96453 8.77538 6.03251 8.96351 6.15235 9.11445C6.27449 9.2632 6.43695 9.37585 6.63975 9.45241C6.84486 9.52679 7.07646 9.56398 7.33457 9.56398C7.58807 9.56398 7.80815 9.52898 7.99481 9.45898C8.18379 9.38898 8.33012 9.29163 8.43383 9.16695C8.53753 9.04226 8.58938 8.89898 8.58938 8.7371C8.58938 8.58616 8.54214 8.45929 8.44765 8.35648C8.35547 8.25366 8.21951 8.16616 8.03975 8.09398C7.8623 8.02179 7.64453 7.95616 7.38642 7.8971L6.61556 7.71335C6.01868 7.57554 5.54741 7.36007 5.20173 7.06695C4.85605 6.77382 4.68436 6.37898 4.68667 5.88241C4.68436 5.47554 4.79844 5.12007 5.02889 4.81601C5.26165 4.51195 5.58082 4.2746 5.98642 4.10398C6.39202 3.93335 6.85292 3.84804 7.36914 3.84804C7.89457 3.84804 8.35317 3.93335 8.74494 4.10398C9.13901 4.2746 9.44551 4.51195 9.66444 4.81601C9.88337 5.12007 9.9963 5.47226 10.0032 5.87257H8.56864Z",
    fill: "#12751F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 3.5,
    fill: "#3AB54A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67578 11.5066L11.2862 12.8544L13.3342 10.1459",
    stroke: "white",
    strokeWidth: 0.931,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaidPrice);
export default __webpack_public_path__ + "static/media/icon-paid-price.ab925d7a7bf3f558512de3db9f9baebe.svg";
export { ForwardRef as ReactComponent };